import React from "react";
import "react-multi-carousel/lib/styles.css";
import TopDestinationMultiRow from "../../../../components/multiRow/TopDestinationMultiRow";
import DestinationProvinces from "./detaildestination/DestinationProvinces";
import BestSeller from "../../homePages/components/BestSeller";

function BodyDestination() {
  return (
    <div className="container mt-5vh">
      <div className="row align-items-stretch">
        {" "}
        <div className="col-lg-1 order-md-1 d-none d-lg-block"></div>
        <div className="col-lg-4 text-center order-md-2 col-md-12 mb-4">
          <TopDestinationMultiRow />
        </div>
        <div className="col-lg-1 order-md-2 d-none d-lg-block"></div>
        <div className="col-lg-5 text-center order-md-2 col-md-12 mb-4">
          <DestinationProvinces />
        </div>
        <div className="col-lg-1 order-md-3 d-none d-lg-block"></div>
        <div className="col-lg-12 text-center order-md-3 col-md-12 mb-4">
          <BestSeller />
        </div>
      </div>
    </div>
  );
}

export default BodyDestination;
